import { Component } from "@theme/component";

class NavigationAccordion extends Component {
  requiredRefs = ['accordionContent'];

  #openHeight = 0;

  connectedCallback() {
    this.setOpenHeight();
  }

  setOpenHeight() {
    return;
    this.refs.content.style.height = 'auto';
    this.#openHeight = this.refs.content.offsetHeight;
    console.log(this.#openHeight);
    this.refs.content?.removeAttribute('style');
    this.refs.content?.setAttribute('--open-height', `${this.#openHeight}px`);
  }

  toggleOpen() {
    console.log(this.refs.accordionContent);
    this.classList.toggle('open');
  }
}

if (!customElements.get("navigation-accordion")) {
  customElements.define("navigation-accordion", NavigationAccordion);
}